import { render, staticRenderFns } from "./SubmitMCPage.vue?vue&type=template&id=586f2896&scoped=true&lang=pug"
import script from "./SubmitMCPage.vue?vue&type=script&lang=js"
export * from "./SubmitMCPage.vue?vue&type=script&lang=js"
import style0 from "./SubmitMCPage.vue?vue&type=style&index=0&id=586f2896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586f2896",
  null
  
)

export default component.exports